import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mouse-pointer",
  "use": "icon-mouse-pointer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-mouse-pointer\" id=\"icon-mouse-pointer\"><path d=\"M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z\" /><path d=\"M13 13l6 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol